<template lang="pug">
div.guest-page.guest-page-body
    div.all-page
        boxy-loader
</template>

<script lang="ts">
import Vue from 'vue';
import BoxyLoader from '@/components/loaders/BoxyLoader.vue';

export default Vue.extend({
  name: 'LoadingContainer',
  components: {
    BoxyLoader,
  },
});
</script>

<style scoped lang="less">
@loaderSize: 100px;
@boxSize: @loaderSize + 60px * 2;

.loader {
    font-size: @loaderSize;
    width: @loaderSize;
    height: @loaderSize;
    margin: 10px;
}
.all-page {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    .boxy {
        width: @boxSize;
        height: @boxSize;
        background: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 15px;
    }
}
</style>

<i18n>
    {
        "en": {
            "Загрузка": "Loading"
        }
    }
</i18n>
